import { isDebug } from '@/utils';

const loaderLogger = (type, preData, nextData) => {
  console.groupCollapsed('loader: ', type);
  console.log(`preData:`, preData);
  console.log(`nextData:`, nextData);
  console.groupEnd();
}

export default class ComposeLoader {
  // startData, preData => nextData
  startData = null;
  decorators = [];

  constructor(startData) {
    this.startData = startData;
  }
  decorate(type, decorator) {
    this.decorators.push({
      type,
      decorator,
    });
  }
  dispatch() {
    let preData = this.startData;
    while(this.decorators.length) {
      const { type, decorator } = this.decorators.shift();
      const nextData = decorator.call(this, preData);
      isDebug && loaderLogger(type, preData, nextData)
      preData = nextData;
    }
    return preData;
  }
}
